var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproveCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check fill 0 weight 300 grad 0 opsz 24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.903 15.8685L18.7148 7.05671L19.0769 7.41881L9.54944 16.9463L4.92195 12.3188L5.28406 11.9567L9.19589 15.8685L9.54944 16.2221L9.903 15.8685Z",
    fill: "currentColor",
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveCheckCircle);
export default __webpack_public_path__ + "static/media/ApproveCheckCircle.7a611b2fd78b6022bd4f48c899d61366.svg";
export { ForwardRef as ReactComponent };